export const SET_SEARCH_CATEGORY = 'SET_SEARCH_CATEGORY';
export const SET_SEARCH_PARAMS = 'SET_SEARCH_PARAMS';
export const SET_SEARCH_ISREPOSITORY = 'SET_SEARCH_ISREPOSITORY';
export const SET_SEARCH_FINISHED = 'SET_SEARCH_FINISHED';
export const APPEND_SEARCH_RESULTS = 'APPEND_SEARCH_RESULTS';
export const CLEAR_SEARCH_DATA = 'CLEAR_SEARCH_DATA';
export const SET_SEARCH_ITEM = 'SET_SEARCH_ITEM';
export const SET_MATERIAL_TYPES = 'SET_MATERIAL_TYPES';
export const SET_MATERIAL_STATUS = 'SET_MATERIAL_STATUS';
export const SET_MATERIAL_SITUATIONS = 'SET_MATERIAL_SITUATIONS';
export const SET_LIBRARIES = 'SET_LIBRARIES';
export const SET_GENERAL_LIBRARIES = 'SET_GENERAL_LIBRARIES';
export const SET_REPOSITORY_ITEM_TYPES = 'SET_REPOSITORY_ITEM_TYPES';